var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.5 0.5C4.97715 0.5 0.5 4.97715 0.5 10.5C0.5 16.0228 4.97715 20.5 10.5 20.5C16.0228 20.5 20.5 16.0228 20.5 10.5C20.4936 4.97982 16.0202 0.506429 10.5 0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 10.2845C11.3112 10.2661 11.2986 10.241 11.2986 10.2149C11.2986 10.1888 11.3112 10.1638 11.3337 10.1454L15.7603 6.50635C16.0402 6.2759 16.0399 5.90254 15.7596 5.67242C15.4793 5.4423 15.0252 5.44256 14.7453 5.67301L10.3192 9.31048C10.2968 9.32895 10.2663 9.33934 10.2346 9.33934C10.2029 9.33934 10.1724 9.32895 10.15 9.31048L5.72392 5.67301C5.44403 5.44278 4.99013 5.44269 4.7101 5.67281C4.43008 5.90293 4.42997 6.27612 4.70987 6.50635L9.13548 10.1454C9.15795 10.1638 9.17058 10.1888 9.17058 10.2149C9.17058 10.241 9.15795 10.2661 9.13548 10.2845L4.70987 13.9239C4.52881 14.0728 4.45814 14.2899 4.52449 14.4933C4.59083 14.6967 4.78411 14.8555 5.03151 14.9099C5.27892 14.9644 5.54286 14.9062 5.72392 14.7573L10.15 11.1178C10.1724 11.0993 10.2029 11.089 10.2346 11.089C10.2663 11.089 10.2968 11.0993 10.3192 11.1178L14.7453 14.7573C15.0252 14.9875 15.4791 14.9876 15.7591 14.7575C16.0391 14.5273 16.0392 14.1541 15.7593 13.9239L11.3337 10.2845Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle2);
export default __webpack_public_path__ + "static/media/check-circle-2.63f2285ba56082f25ec2422158bcb4c7.svg";
export { ForwardRef as ReactComponent };